import { CSSProperties } from 'react';
import { PeriodScoreElement } from '../../models/api/codegen/code';

interface ICell {
    value: string | number;
    color: CSSProperties['color'];
}

interface IHeader {
    cells: ICell[];
}

interface ITable {
    homeScores: ICell[];
    awayScores: ICell[];
}

export interface IScores {
    header: IHeader;
    scoresTable: ITable;
    columnsNumber: number;
}

/**
 * Функция парсинга очков и периодов для таблицы результатов матча
 *
 * @param t Функция i18n для встраивания переводов
 * @param {PeriodScoreElement[]} periods периоды, полученные из результатов матча
 * @param {number} homeScore очки первой команды (хозяева)
 * @param {number} awayScore очки второй команды (гости)
 *
 * @returns {IScores} структура для построения таблицы очков матча
 * @function
 * @see IScores
 */

export const scoreTableParser = (
    t: any,
    periods?: PeriodScoreElement[],
    homeScore?: number,
    awayScore?: number
): IScores => {
    const scores: IScores = {
        header: {
            cells: []
        },
        scoresTable: {
            homeScores: [],
            awayScores: []
        },
        columnsNumber: 0
    };

    if (!periods) {
        return scores;
    }

    periods
        .sort((a, b) => {
            const A = a && a.periodNumber ? a.periodNumber : 0;
            const B = b && b.periodNumber ? b.periodNumber : 0;
            return A > B ? 1 : A < B ? -1 : 0;
        })
        .map(period => {
        scores.header.cells.push({
            color: '#adabab',
            value: period.periodNumber || '-'
        });

        scores.scoresTable.homeScores.push({
            color: '',
            value: period.homeScore || '-'
        });

        scores.scoresTable.awayScores.push({
            color: '',
            value: period.awayScore || '-'
        });

        scores.columnsNumber += 1;
    });

    if (
        homeScore !== null &&
        homeScore !== undefined &&
        awayScore !== null &&
        awayScore !== undefined
    ) {
        scores.header.cells.push({
            color: '#ffdb4d',
            value: t('fixture.score')
        });
    }

    if (homeScore != null || awayScore != null) {
        scores.scoresTable.homeScores.push({
            color: '#ffdb4d',
            value: homeScore == null ? '-' : homeScore
        });

        scores.scoresTable.awayScores.push({
            color: '#ffdb4d',
            value: awayScore == null ? '-' : awayScore
        });

        scores.columnsNumber += 1;
    }

    return scores;
};
